export const BASE_DASHB_EVENT_PROPS = {
  page: "subscription_details",
};

export const DASHBOARD_EVENTS = {
  // Subscription management
  MANAGE_CTA: "manage_subscription_clicked",
  PURCHASE_CTA: "purchase_clicked",

  PAYMENT_DETAILS: "payment_details_clicked",
  REACTIVATE_CTA: "reactivate_clicked",
  RESUME_CTA: "resume_clicked",

  // Plan switching
  SWITCH_TO_YEARLY: "yearly_upsell_clicked",
  // Fires on every open of the switch-to-yearly dialog, banner click or deep link
  // alike — SWITCH_TO_YEARLY stays click-only so its existing counts keep meaning
  // "clicked". Read `entry_point` to split the two.
  INTERVAL_SWITCH_MODAL_VIEWED: "interval_switch_modal_viewed",
  PLAN_SWITCH_CONFIRMED: "plan_switch_confirmed",
  INTERVAL_SWITCH_PROMO_APPLIED: "interval_switch_promo_applied",
  INTERVAL_SWITCH_PROMO_REMOVED: "interval_switch_promo_removed",

  // Upgrades
  BILLING_TOGGLE_CHANGED: "billing_toggle_changed",
  UPGRADE_PLAN: "upgrade_clicked",
  PLAN_ADD: "plan_added",
  ADDON_ADD: "addon_add_clicked",

  // Payment & billing
  ADD_PAYMENT_METHOD: "add_payment_method_clicked",
  ADD_BILLING_ADDRESS: "add_billing_address_clicked",
} as const;

export type TDashboardEvent =
  (typeof DASHBOARD_EVENTS)[keyof typeof DASHBOARD_EVENTS];
